module.exports = __webpack_public_path__ + "img/caolv.6ae3de3a.png";